if (!customElements.get('regalia-product-showcase')) {
  customElements.define(
    'regalia-product-showcase',
    class RegaliaProductShowcase extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onThumbnailClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onThumbnailClick);
      }

      onThumbnailClick(event) {
        const thumbnail = event.target.closest('[data-regalia-thumbnail]');
        if (!thumbnail) return;

        const card = thumbnail.closest('[data-regalia-card]');
        const image = card?.querySelector('[data-regalia-main-image]');
        if (!image) return;

        card.querySelectorAll('[data-regalia-thumbnail]').forEach((button) => {
          button.setAttribute('aria-current', String(button === thumbnail));
        });

        image.style.opacity = '0';
        window.setTimeout(() => {
          image.src = thumbnail.dataset.src;
          image.srcset = thumbnail.dataset.srcset || '';
          image.alt = thumbnail.dataset.alt || '';
          image.style.opacity = '1';
        }, 120);
      }
    }
  );
}
